// extracted by mini-css-extract-plugin
module.exports = {"container":"closeButton_container__2Oy4o","icon":"closeButton_icon__3sNV8"};